import React from "react";

const timeConver = (milliseconds) => {
  let date = new Date(milliseconds);

  return date.toUTCString();
};

export default timeConver;
